import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const invitation_collaborate_product = apiUrl + "/invitation_collaborate_product";
const routes = {
  label: "Invitation Collaborate Product",
  root: invitation_collaborate_product,
  send: invitation_collaborate_product + "/send",
  accept: invitation_collaborate_product + "/accept",
  reject: invitation_collaborate_product + "/reject",
  get_my_pending_invitations_received: invitation_collaborate_product + "/get_my_pending_invitations_received",
};
export const InvitationCollaborateProduct = {
  get_my_pending_invitations_received: () => postWithToken(routes.get_my_pending_invitations_received),
  accept: (invitation_id) => postWithToken(routes.accept, { invitation_id }),
  reject: (invitation_id) => postWithToken(routes.reject, { invitation_id }),
  send: (ids, receiver_id) => postWithToken(routes.send, { ids, receiver_id }),
};
